import './styles/default.scss';
import { JackpotDescription } from '../../subcomponents/daily-jackpot/daily-jackpot-description';
import { JackpotAmountAndTime } from '../../subcomponents/daily-jackpot/daily-jackpot-amount-time';
import type { DailyJackpotData, DailyJackpotPrimary } from '@/types/zones/slices/daily-jackpot';
import type { LauncherUrlProps } from '@/utils/url/launcher-url';
import { GameUrl } from '@/app/components/game/subcomponents/game-url/game-url';
import { removeProductFromUid } from '@/utils/url/url';
import { getGameName, getImageSmallUrl } from '@/logic/game-adapter/game-adapter';

type DailyJackpotGameProps = {
    zoneData: DailyJackpotPrimary;
    gameProps: DailyJackpotData;
    launcherUrlProps: LauncherUrlProps;
    isPopup: boolean;
    tracking: {
        gameUid: string;
        gamePosition: number | null;
        gameName: string;
        gameProvider: string;
    };
};

export const DailyJackpotGame: React.FC<DailyJackpotGameProps> = ({
    launcherUrlProps,
    zoneData,
    gameProps,
    tracking
}) => {
    const infoButtonLink = removeProductFromUid(zoneData?.info_button?.uid || '');
    const logoUrl = getImageSmallUrl(gameProps.item.data?.logo);
    const backgroundUrl = getImageSmallUrl(gameProps.item.data?.background);

    // TODO: alts
    return (
        <GameUrl launcherUrlProps={launcherUrlProps}>
            <div
                className="daily-jackpot-game"
                data-t-gameuid={tracking.gameUid}
                data-t-gameposition={tracking.gamePosition}
                data-t-gamename={tracking.gameName}
                data-t-gameprovider={tracking?.gameProvider}>
                <img src={backgroundUrl} loading="lazy" className="background" />
                <img src={logoUrl} loading="lazy" className="logo" />
                <div className="data">
                    <img
                        src={`/images/daily-jackpot-logo-tile-${process.env.BRAND}.png`}
                        loading="lazy"
                        className="jackpot-logo"
                    />
                    <div className="game-title">{getGameName(gameProps.item.data?.display_name)}</div>
                    <JackpotDescription
                        jackpotFromContent={zoneData}
                        feedsCode={gameProps?.item?.data?.feeds_code_mobile}
                        isJustWonState={false}
                        showDescription={false}
                    />
                    <JackpotAmountAndTime
                        feedsCode={gameProps.item.data?.feeds_code_desktop}
                        infoButtonLink={infoButtonLink}
                    />
                </div>
            </div>
        </GameUrl>
    );
};
